import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLockOpen = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M6.429 12.666c-.632 0-1.143.507-1.143 1.133v6.8c0 .627.511 1.134 1.143 1.134h11.428c.631 0 1.143-.507 1.143-1.133v-6.8c0-.627-.512-1.134-1.143-1.134H6.43ZM3 13.799c0-1.878 1.535-3.4 3.429-3.4h11.428c1.894 0 3.429 1.522 3.429 3.4v6.8c0 1.879-1.535 3.4-3.429 3.4H6.43C4.535 24 3 22.479 3 20.6v-6.8Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M9.857 17.2a2.276 2.276 0 0 1 2.286-2.267 2.276 2.276 0 0 1 2.286 2.267 2.276 2.276 0 0 1-2.286 2.266A2.276 2.276 0 0 1 9.857 17.2Zm2.286-14.735c-.91 0-1.782.358-2.425.996a3.386 3.386 0 0 0-1.004 2.404v5.667c0 .626-.511 1.134-1.143 1.134a1.138 1.138 0 0 1-1.142-1.134V5.865c0-1.503.602-2.944 1.673-4.007a5.738 5.738 0 0 1 4.04-1.66c1.516 0 2.97.597 4.041 1.66a5.643 5.643 0 0 1 1.674 4.007c0 .626-.512 1.134-1.143 1.134a1.138 1.138 0 0 1-1.143-1.134c0-.901-.36-1.766-1.004-2.404a3.443 3.443 0 0 0-2.424-.996Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLockOpen);
export default ForwardRef;
